import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "./context/AuthContext.js";
import MarketingLayout from "./components/MarketingLayout.js";
import "./SuccessPage.css";

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const { refreshPlan } = useAuth();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (sessionId) {
      setTimeout(() => {
        refreshPlan();
      }, 2000);
    }
  }, [sessionId, refreshPlan]);

  return (
    <MarketingLayout>
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon">✓</div>
        <h1>Payment Successful!</h1>
        <p>Thank you for your subscription. Your plan has been activated.</p>
        {sessionId && (
          <p className="session-id">Session ID: {sessionId}</p>
        )}
        <div className="success-actions">
          <Link to="/chatbot-page" className="success-button primary">
            Go to Dashboard
          </Link>
          <Link to="/pricing" className="success-button secondary">
            View Plans
          </Link>
        </div>
      </div>
    </div>
    </MarketingLayout>
  );
}

